var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown"},[_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-file"}),_vm._v(" "+_vm._s(_vm.item.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }